import { useState, useEffect } from "react";
import "./AppHeader.css";
import { AppSearch } from "../app-search/AppSearch";

type AppHeaderProps = {
   
}

export const AppHeader = ({} : AppHeaderProps) => {
    return (
        <>
            <div className="app-header">
                <AppSearch />
            </div>
        </>

    )
}